import React, { Component } from 'react';
import './card-wrap.style.css';

import FeedContainer from '../feed-container/feed-container.component';
import TimeFilter from '../time-filter/time-filter.component';
import queryString from 'query-string'

import axios from 'axios'
import UserContext from '../../utils/userContext'
import FeedHighlight from '../feed-highlight/feed-highlight.component';
import BlogBookmark from '../blog-bookmark/blog-bookmark.component';



export default class CardWrap extends Component {
    static contextType = UserContext
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            filterList: [
                'day',
                'week',
                'month',
                'year',
                'lastest'
            ],
            firstPostsQuery: false,
            focusFilter: 'lastest',
            page: 0,
            loadMoreStatus: "loading",
            tagData: null
        };
        this.handleScroll = this.handleScroll.bind(this)

    }

    onFilterClick(filter) {
        this.setState({ focusFilter: filter, firstPostsQuery: false, page: 0 })
        // this.getPostUpdate(filter)
    }

    setTagData() {
        const tag = this.props.match.params.tagName;

        if (tag) {
            const self = this;
            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/tags/detail?q=${tag}`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {

                    if (response.data.success) {

                        self.setState({ tagData: response.data.tagData })
                    } else {
                        self.setState({ tagData: null })
                    }
                })
                .catch(function (response) {

                });
        } else {
            this.setState({ tagData: null })
        }
    }



    getPostUpdate(filter = this.state.focusFilter, page = 0) {
        const limit = 15
        // console.log("filter: " + filter + page + limit)
        const self = this
        let reqPath = `https://www.borntodev.com/wp-json/devblog/v1/posts/filter/${filter.toLowerCase()}?page=${page}&limit=${limit}`
        if (this.props.match.params.tagName !== undefined) {
            reqPath = `https://www.borntodev.com/wp-json/devblog/v1/posts/tag/${this.props.match.params.tagName}/filter/${filter.toLowerCase()}?page=${page}&limit=${limit}`
        }
        if (queryString.parse(this.props.location.search).q) {
            reqPath = `https://www.borntodev.com/wp-json/devblog/v1/search/${filter.toLowerCase()}?q=${(queryString.parse(this.props.location.search).q)}&page=${page}&limit=${limit}`
        }
        axios({
            method: 'get',
            url: reqPath,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                // console.log("page" + page)
                if (response.data.length === 0) {
                    if (self.state.page === 0) {
                        // console.log("len0page0")
                        self.setState({ posts: response.data, loadMoreStatus: "empty", firstPostsQuery: true })
                    } else {
                        // console.log("len0page+")
                        self.setState({ loadMoreStatus: "empty" })
                    }

                }
                else if (page === 0) {
                    // console.log("page0")
                    self.setState({ posts: response.data, firstPostsQuery: true, page: 1, loadMoreStatus: "readyLoad" })
                } else {
                    // console.log("page+")
                    self.setState(prevState => ({
                        posts: [...prevState.posts.concat(response.data)],
                        page: self.state.page + 1,
                        loadMoreStatus: "readyLoad"
                    }))
                }

            })
            .catch(function (response) {

            });
    }

    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll);

        let filterPath = this.props.match.params.filterName
        // console.log(filterPath)
        if (filterPath === undefined) {
            filterPath = "lastest"
        }

        this.onFilterClick(filterPath)
        this.getPostUpdate(filterPath)
        this.setTagData()
    }

    componentDidUpdate(prevProps) {

        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
            this.setState({ firstPostsQuery: false, page: 0 })

            if(this.props.match.params.tagName !== prevProps.match.params.tagName){
                this.onFilterClick('lastest')
                this.getPostUpdate('lastest')
            }else{
                this.getPostUpdate()
            }

            this.setTagData()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {

        // console.log(document.documentElement.scrollHeight - (window.pageYOffset + document.documentElement.clientHeight))

        if (document.documentElement.scrollHeight - (window.pageYOffset + document.documentElement.clientHeight) < 1500) {
            if (this.state.loadMoreStatus === "readyLoad") {
                this.setState({ loadMoreStatus: "loading" })
                this.getPostUpdate(this.state.focusFilter, this.state.page)

            }

        }

    }

    render() {

        return (
            <div className="wrap">

                <div className="content-wrap inner-bg-color">
                    <div style={{ backgroundColor: 'white', display: 'flex' }}>
                        <div>
                        </div>
                    </div>
                    <div>
                        <FeedHead tagData={this.statefirstPostsQuery ? null : this.state.tagData} tagName={this.props.match.params.tagName} searchText={queryString.parse(this.props.location.search).q} />
                    </div>

                    {queryString.parse(this.props.location.search).q ?  <></> : <div className="card-wrap">
                        <FeedHighlight tagName={this.props.match.params.tagName}/>
                    </div>}

                    <div className="blog-feed-wrap">
                        <FeedContainer path={`${this.props.match.url}`} posts={this.state.posts} firstPostsQuery={this.state.firstPostsQuery} pathName={this.props.location.pathname} searchText={queryString.parse(this.props.location.search).q} noMore={this.state.loadMoreStatus} />
                        <div className="side-menu-wrap">
                            <TimeFilter filterList={this.state.filterList} focusFilter={this.state.focusFilter} onFilterClick={this.onFilterClick.bind(this)} tagName={this.props.match.params.tagName} searchText={queryString.parse(this.props.location.search).q}/>
                            <BlogBookmark />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const FeedHead = (props) => {

    const headTitle =
        props.tagName === undefined && props.searchText === undefined ?
            <span className="header-yellow">แชร์ทักษะ ตั้งคำถาม</span>
            :
            props.searchText !== undefined ?
                <><span className="header-yellow">ค้นหา: </span>{props.searchText}</>
                :
                props.tagData ?
                    props.tagName === props.tagData.tagName ?
                        <span style={{ color: props.tagData.tagColor1 }}>{props.tagData.tagName}</span>
                        :
                        <><span className="header-yellow">แท็ก: </span>{props.tagName}</>
                    :
                    <><span className="header-yellow">แท็ก: </span>{props.tagName}</>

    const headDes = props.tagData ?
        props.tagName === props.tagData.tagName ?
            props.tagData.tagDescription
            :
            <>ด้วยหลักสูตรที่ลงลึกจัดเต็มด้านการเรียนเขียนโปรแกรม<br />จากผู้มีประสบการณ์เชี่ยวชาญด้านเทคโนโลยีตัวจริง</>
        :
        <>ด้วยหลักสูตรที่ลงลึกจัดเต็มด้านการเรียนเขียนโปรแกรม<br />จากผู้มีประสบการณ์เชี่ยวชาญด้านเทคโนโลยีตัวจริง</>

    const headSub = props.tagData ?
        props.tagName === props.tagData.tagName ?
            ""
            :
            "อัพสกิลสายดิจิทัลไปพร้อมกัน"
        :
        "อัพสกิลสายดิจิทัลไปพร้อมกัน"



    const headImage = props.tagData ?
        props.tagName === props.tagData.tagName ?
            <div className="header-image" style={{ backgroundImage: `url(${props.tagData.tagLogo})` }}></div>
            :
            ""
        :
        ""



    return (
        <div className="blog-header">
            <div>
                {headImage}
            </div>
            <div className="ml-20px">
                <div className="blog-header-title">{headTitle}</div>
                <div className="blog-header-subtitle">{headSub}</div>
                <div className="blog-header-desc">{headDes}</div>
            </div>
        </div>
    )
}




